import api from '../Auth/api';
import { createEffect, createEvent, createStore } from 'effector';
import { setPermissionsStatus } from './permissions';
import { updateModal } from '../components/ErrorModal';

export const $editPermissionStatus = createStore(null);
export const $permissionFetching = createStore(false);

export const setEditPermissionFetching = createEvent();
export const setEditPermissionStatus = createEvent();

export const revokePermissionFx = createEffect(async (permissionData) => {
    const response = api.post(`/rbac/${permissionData.type}-role`, {
        roleId: permissionData.roleId,
        userId: permissionData.userId
    });
    response.then(null, error => updateModal(error.response.data.errors))
    return response;
});

export const deletePermissionFx = createEffect(async (permissionData) => {
    const response = api.delete(`/rbac/role`, {
        data: {
            id: permissionData.roleId
        }
    });
    response.then(null, error => updateModal(error.response.data.errors))
    return response;
});

$editPermissionStatus.on(setEditPermissionStatus, (_, status) => status);

$editPermissionStatus.on([revokePermissionFx, deletePermissionFx], () => {
    setEditPermissionFetching(true);
});
$editPermissionStatus.on([revokePermissionFx.done, deletePermissionFx.done], () => {
    setTimeout(() => {
        setEditPermissionStatus(null);
        setPermissionsStatus('ok');
    }, 2000);

    setPermissionsStatus('shouldUpdate');
    return 'success';
});
$editPermissionStatus.on(revokePermissionFx.fail, () => 'error');
$editPermissionStatus.on(revokePermissionFx.finally, () => {
    setEditPermissionFetching(false);
});
